import { __ } from '@wordpress/i18n'
import SbUtils from '../../Utils/SbUtils'
import Button from './Button';
import Checkbox from './Checkbox';

const Source = ( props ) => {

    return (
        <div
            className={ 'sb-source-item ' + ( props?.customClass ? props?.customClass : '' ) }
            data-checked={props.isChecked}
            onClick={ ( event ) => {
                event.stopPropagation()
                event.preventDefault()
                if( props?.onClick )
                    props.onClick()
            }}
        >
            <div className='sb-source-item-top sb-fs'>
                {
                    ( props?.checkbox || props?.radiobox ) &&
                    <div className='sb-source-item-box'>
                        {
                            props.checkbox &&
                            <Checkbox
                                value={ props.isChecked }
                                enabled={ true }
                                onChange={ () => {
                                    if( props?.onClick )
                                        props.onClick()
                                }}
                            />
                        }
                        {
                            props.radiobox &&
                            <Checkbox
                                value={ props.isChecked }
                                enabled={ true }
                                onChange={ () => {
                                    if( props?.onClick )
                                        props.onClick()
                                }}
                            />
                        }
                    </div>
                }
                <div className='sb-source-item-icon'>
                    <span className='sb-source-item-avatar'>
                        <img src={ props.avatar } alt={ props.name } />
                    </span>
                </div>

                <div className='sb-source-item-info'>
                    <span className='sb-text-small sb-bold'>{ props.name }</span>
                    <span className='sb-dark2-text sb-text-tiny'>{ __('Used in 0 Feeds', 'sb-customizer') }</span>
                </div>
                {
                    ( props?.removeIcon || props?.infoIcon ) &&
                        <div className='sb-source-act-ctn'>
                            {
                                props?.removeIcon &&
                                <div className='sb-source-item-remove-icon sb-source-act-icon-ctn'>
                                    <div
                                        className='sb-source-act-icon sb-tr-2'
                                        onClick={ () => {
                                            if( props?.onRemoveClick )
                                                props.onRemoveClick()
                                        }}
                                    >
                                        { SbUtils.printIcon( 'trash', false, false, 11  ) }
                                    </div>
                                </div>
                            }
                            {
                                props?.infoIcon &&
                                <div className='sb-source-item-info-icon sb-source-act-icon-ctn'>
                                    <div
                                        className='sb-source-act-icon sb-tr-2'
                                        onClick={ () => {
                                            props.onShowInfoClick()
                                        }}
                                    >
                                        { SbUtils.printIcon( 'cog', false, false, 15 ) }
                                    </div>
                                </div>
                            }
                        </div>
                }
            </div>
            {
                ( props?.infoIcon && props?.isCollapsed === true  ) &&
                <div className='sb-source-dp-info sb-fs'>
                    <div className='sb-source-dp-info-item'>
                        <strong>Open ID</strong>
                        <span>{ props.openId }</span>
                        <Button
                            icon='copy'
                            type='secondary'
                            size='small'
                            boxshadow={false}
                            onClick={ () => {
                                SbUtils.copyToClipBoard( props.openId, props.editorNotification )
                            } }
                        />
                    </div>
                </div>
            }
        </div>
    )
}

export default Source;